import { h } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import { Filter } from './Filter';
import styles from './FilterPanel.module.scss';
export function FilterPanel({ filters, onFilterChange, onClearAll, totalResults, layout, openFilterDrawer, setOpenFilterDrawer }) {
    const [isContentScrolled, setIsContentScrolled] = useState(false);
    const [showFooterShadow, setShowFooterShadow] = useState(false);
    const contentRef = useRef(null);
    const updateScrollState = (target) => {
        const { scrollTop, scrollHeight, clientHeight } = target;
        const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;
        setIsContentScrolled(scrollTop > 0);
        setShowFooterShadow(!isAtBottom);
    };
    useEffect(() => {
        if (contentRef.current) {
            updateScrollState(contentRef.current);
        }
    }, [filters, layout, openFilterDrawer]);
    const selectedFilters = filters.flatMap(filter => (filter.options || [])
        .filter(option => option.selected)
        .map(option => ({
        filterId: filter.id,
        filterLabel: filter.label,
        optionId: option.id,
        optionLabel: option.label,
    })));
    return (h("div", { class: styles.filterPanelContainer },
        h("div", { ref: contentRef, class: styles.filterPanelContent, onScroll: (event) => {
                const target = event.currentTarget;
                updateScrollState(target);
            } },
            h("div", { class: `${styles.filterPanelHeader} ${isContentScrolled ? styles.filterPanelHeaderScrolled : ''}` },
                h("div", { class: styles.filterPanelHeading }, "Filters"),
                h("div", { class: styles.filterPanelClose, onClick: () => setOpenFilterDrawer(false) },
                    h("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        h("mask", { id: "mask0_1479_29604", style: "mask-type:alpha", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "32", height: "32" },
                            h("rect", { width: "32", height: "32", fill: "#D9D9D9" })),
                        h("g", { mask: "url(#mask0_1479_29604)" },
                            h("path", { d: "M10.9693 22.4487L9.55127 21.0307L14.5819 16.0001L9.55127 11.0027L10.9693 9.58472L15.9999 14.6154L20.9973 9.58472L22.4153 11.0027L17.3846 16.0001L22.4153 21.0307L20.9973 22.4487L15.9999 17.4181L10.9693 22.4487Z", fill: "#474747" }))))),
            selectedFilters.length > 0 && (h("div", { class: styles.selectedFilters }, selectedFilters.map(({ filterId, filterLabel, optionId, optionLabel }) => (h("button", { key: `${filterId}-${optionId}`, class: styles.filterChip, onClick: () => onFilterChange(filterId, optionId) },
                filterLabel,
                ": ",
                optionLabel,
                h("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    h("mask", { id: "mask0_1479_29822", style: "mask-type:alpha", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "24", height: "24" },
                        h("rect", { width: "24", height: "24", fill: "#D9D9D9" })),
                    h("g", { mask: "url(#mask0_1479_29822)" },
                        h("path", { d: "M8.22707 16.8365L7.16357 15.773L10.9366 12L7.16357 8.25198L8.22707 7.18848L12.0001 10.9615L15.7481 7.18848L16.8116 8.25198L13.0386 12L16.8116 15.773L15.7481 16.8365L12.0001 13.0635L8.22707 16.8365Z", fill: "#474747" })))))))),
            h("div", { class: layout === 'filterTop' ? styles.filterPanel : styles.filterPanelSide }, filters
                .filter(filter => filter.type === 'range' || (filter.options && filter.options.length > 0))
                .map(filter => (h(Filter, { layout: layout, key: filter.id, filter: filter, onFilterChange: onFilterChange }))))),
        h("div", { class: `${styles.filterPanelFooter} ${showFooterShadow ? styles.filterPanelFooterScrolled : ''}` },
            h("button", { class: styles.clearAllButton, onClick: onClearAll, disabled: selectedFilters.length === 0 }, "CLEAR ALL"),
            h("button", { class: styles.showResultsButton, onClick: () => setOpenFilterDrawer(false) },
                "Show Results [",
                totalResults,
                "]",
                h("svg", { width: "15", height: "12", viewBox: "0 0 15 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    h("path", { d: "M9.34625 11.3075L8.29225 10.223L12.1115 6.40375H0V4.90375H12.1115L8.29225 1.0845L9.34625 0L15 5.65375L9.34625 11.3075Z", fill: "currentColor" }))))));
}
